document.addEventListener('DOMContentLoaded', function () {
    var domElement = document.getElementById("sidebarmenu_body");

    if (!domElement)
        return;

    var ticking = false;
    var transX = 0;
    var lastX = 0;

    domElement.addEventListener('touchstart', function (e) {
        lastX = e.changedTouches[0].pageX;
        transX = 0;
    });

    domElement.addEventListener('touchend', onTouchEnd);

    function onTouchEnd(e) {
        if (ticking == true) {
            setTimeout(function () { onTouchEnd(e); }, 100);
        }
        else {
            requestElementUpdate('translate3d(0px, 0px, 0)');
        }
    }

    domElement.addEventListener('touchmove', function (e) {
        e.preventDefault();
        const x = e.changedTouches[0].pageX;
        const dx = x - lastX;
        lastX = x;

        if (dx < 0 || transX < 0) {
            transX += dx;
            if (transX > 0) transX = 0;
            var transformString = 'translate3d(' + transX + 'px, 0px, 0)';
            requestElementUpdate(transformString);
        }
    });

    function requestElementUpdate(transformString) {
        if (!ticking) {
            animationFrameId = requestAnimationFrame(function (timestamp) {
                domElement.style.transform = transformString;

                animationFrameId = null;
                ticking = false;

            });
            ticking = true;
        }
    }
});


